import request from './request'

const isProd = process.env.NODE_ENV === 'production'
const prodUrl= ''
const devUrl = ''
const baseURL =  isProd ? prodUrl : devUrl
const custom =  baseURL + 'CUSTOMER-SERVE'

export function findBicList(data) {
  return request({
    url: custom + '/bic-vallist/findList',
    method: 'post',
    data
  })
}

export function changeStatus(data) {
  return request({
    url: custom + '/bic-vallist/changeStatus',
    method: 'post',
    data
  })
}

export function getBicInfo(data) {
  return request({
    url: custom + '/bic-vallist/getBicInfo',
    method: 'post',
    data
  })
}

export function savaBicTypeInfo(data) {
  return request({
    url: custom + '/bic-vallist/savaBicType',
    method: 'post',
    data
  })
}

export function savaBicValTypeInfo(data) {
  return request({
    url: custom + '/bic-vallist/savaBicValType',
    method: 'post',
    data
  })
}

